import React from "react"
import { MainArticleLayout } from "../../../layouts/MainArticleLayout"
import { Button } from "semantic-ui-react"
import { useHistory } from "react-router-dom"
import { BookmarksDeleteRequest } from "../../../models/Bookmarks"
import BookmarksService from "../../../services/BookmarksService"
import Protected from "../../Protected"

const DeleteBookmarks = () => { 
    const history = useHistory()
    const queryParams = new URLSearchParams(location.search)
    const bookmarType = queryParams.get('type')
    
    const cancelDelete = () => {
      if(bookmarType === 'awards') {
        history.push('/my-account/bookmarked-awards')
      }
      if(bookmarType === 'pages') {
        history.push('/my-account/bookmarked-pages')
      }
      if(bookmarType === 'results') {
        history.push('/my-account/bookmarked-results')
      }

      }

      const removeBookmark = async () => {

        const req = new BookmarksDeleteRequest()
        req.id = queryParams.get('id')
        return await BookmarksService.removeBookmark(req).then(
            (response) => {
              if (response.result) {
                if(bookmarType === 'awards') {
                history.push('/my-account/bookmarked-awards')
                }
                if(bookmarType === 'pages') {
                  history.push('/my-account/bookmarked-pages')
                }
                if(bookmarType === 'results') {
                  history.push('/my-account/bookmarked-results')
                }
              }
            }
          )
      }
    return (
<>
<Protected>
<MainArticleLayout>
        <div className="content-wrapper">
          
        <h4>Confirm</h4>
        <hr />
        <p></p>
        
        <p></p>
       
        <p>Are you sure you want to delete this bookmark?</p>
        <p></p>
        <p></p>
        <p></p>
        <hr />
        <p></p>
        <p></p>
        <Button
          type="button"
          className="ui button is-secondary"
          onClick={cancelDelete}
        >
          Cancel
        </Button>
        <Button className="ui is-primary button" onClick={removeBookmark}>
          Confirm
        </Button>
        
        </div>
        </MainArticleLayout>
        </Protected>
        </>

    )
}
export default DeleteBookmarks